// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect } from 'react';
import { app } from '@microsoft/teams-js';
import { getAuthenticationConsentMetadata } from '../../utils/getAuthenticationConsentMetadata';
import { useSearchParams } from 'react-router';

const SignInSimpleStart = () => {
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const init = async () => {
            if (!app.isInitialized()) {
                await app.initialize();
            }
            const context = await app.getContext();
            const windowLocationOriginDomain = window.location.origin.replace(
                'https://',
                ''
            );
            const login_hint = context.user?.userPrincipalName ?? '';

            const state = searchParams.get('state') ?? '';

            const result = await getAuthenticationConsentMetadata(
                windowLocationOriginDomain,
                login_hint,
                state
            );
            window.location.assign(result.data);
        };
        init().catch(console.error);
    });

    return <></>;
};

export default SignInSimpleStart;
